import { SchemaControl, type SchemaControlArgs } from '@/modules/common/models/schema/schema-control.ts';
import type { DateTime } from 'luxon';
import type { DateCopy, Deadline, Direction } from '@/modules/common/types/ui.ts';
import UiDeadline from '@/modules/ui/components/ui/UiDeadline.vue';
import Validator from '@/modules/common/utils/validator.ts';

type DeadlineApiFns = {
  getDeadline: (parameters: { days: number; from?: DateTime }, signal?: AbortSignal) => Promise<DateTime>;
  getWorkDaysDiff: (parameters: { from: DateTime; to: DateTime }, signal?: AbortSignal) => Promise<number>;
};

type SchemaDeadlineArgs = SchemaControlArgs &
  DeadlineApiFns & {
    today?: boolean;
    direction?: Direction;
    from?: DateTime;
    copy?: DateCopy;
    fullWidth?: boolean;
    correct?: boolean;
    controls?: boolean;
    validate?: boolean;
  };

export class SchemaDeadline extends SchemaControl<Deadline> {
  readonly component = UiDeadline;
  readonly today: boolean;
  readonly direction?: Direction;
  readonly from?: DateTime;
  readonly copy?: DateCopy;
  readonly fullWidth?: boolean;
  readonly correct?: boolean;
  readonly controls: boolean;
  readonly validate: boolean;
  readonly getDeadline: DeadlineApiFns['getDeadline'];
  readonly getWorkDaysDiff: DeadlineApiFns['getWorkDaysDiff'];

  constructor(args: SchemaDeadlineArgs) {
    super(args);

    this.today = !!args.today;
    this.direction = args.direction;
    this.from = args.from;
    this.copy = args.copy;
    this.fullWidth = args.fullWidth;
    this.correct = args.correct;
    this.controls = args.controls !== false;
    this.getDeadline = args.getDeadline;
    this.getWorkDaysDiff = args.getWorkDaysDiff;

    this.validate = args.validate !== false;
    if (this.validate) {
      this.setValidators(this.today);
    }
  }

  private setValidators(today: boolean) {
    this.addValidator(today ? Validator.deadlineMoreOrEqualThanToday : Validator.deadlineMoreThanToday);
  }
}
